import { CARD_DESCRIPTION_UNSAVED_LOCALSTORAGE, ICardDescriptionUnsavedLocalStorage } from '../types';

export const getCardDescriptionUnsavedLocalStorage = (): ICardDescriptionUnsavedLocalStorage => {
    const data = localStorage.getItem(CARD_DESCRIPTION_UNSAVED_LOCALSTORAGE);
    const cardDescriptionUnsaved = data? JSON.parse(data): {};
    return cardDescriptionUnsaved;
};
